import termometro from './tipos/termometro';
import manometro from './tipos/manometro';
import valvula from './tipos/valvula';
import calibradorPneu from './tipos/calibradorPneu';
import pressostato from './tipos/pressostato';
import incubadora from './tipos/incubadora';

// Cada tipo de calibracao aponta para o seu arquivo de campos.
// Os tipos ainda sem arquivo proprio aparecem como "em construcao".
const DEFINICOES = {
  termometro: termometro,
  manometro: manometro,
  valvula: valvula,
  calibrador_pneu: calibradorPneu,
  pressostato: pressostato,
  incubadora: incubadora
};

export const NOMES = {
  manometro: 'Manômetro',
  valvula: 'Válvula de Segurança',
  termometro: 'Termômetro',
  calibrador_pneu: 'Calibrador de Pneu',
  pressostato: 'Pressostato',
  incubadora: 'Incubadora'
};

export default DEFINICOES;
